
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import logo from "./assets/logo3.png";
function Navbar() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false);
  const [open5, setOpen5] = useState(false);

  const menuRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const mobileToggleRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        mobileToggleRef.current &&
        !mobileToggleRef.current.contains(event.target)
      ) {
        setOpen(false);
        setOpen2(false);
        setOpen3(false);
        setOpen4(false);
        setOpen5(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  const { t } = useTranslation();
  return (
    <div className="font-helvetica" >
      <div>
        {/* Navbar for Mobile */}
        <div ref={mobileToggleRef} className="flex md:hidden justify-between items-center px-6 py-4 bg-slate-400 text-black">
          <h1 className="text-xl font-bold">Blue Shark</h1>
          {/* Hamburger button */}
          <button onClick={() => setOpen3(!open3)}>
            ☰
          </button>
        </div>

        {/* Sidebar Mobile */}
        <div ref={mobileMenuRef} className={`fixed top-0 left-0 h-full w-64 bg-slate-400 text-black transform  z-50 ${open3 ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 md:hidden`} >

          <button className="absolute top-4 right-4 text-2xl" onClick={() => setOpen3(false)}>
            ✕ </button>
          <ul className="mt-16 flex flex-col gap-2 px-4 text-lg ">
            <div className="relative p-4 ">
              <button onClick={() => setOpen(!open)} className="px-4 py-2 bg-slate-400 rounded hover:bg-slate-500" >
                🌐 {i18n.language.toUpperCase()}
              </button>
              {open && (
                <ul className="absolute z-50 mt-2 w-24 bg-white text-black rounded shadow-lg">
                  <li onClick={() => changeLanguage("en")} className="px-4 py-2 hover:bg-gray-200 cursor-pointer" >
                    EN
                  </li>
                  <li
                    onClick={() => changeLanguage("ar")} className="px-4 py-2 hover:bg-gray-200 cursor-pointer" >
                    AR
                  </li>
                </ul>
              )}</div>
            <div className="relative p-4 ">
              <button onClick={() => setOpen2(!open2)} className="bg-slate-400 text-black hover:text-gray-700 transition flex items-center gap-2 text-left">
                🌊 {t("services")}
              </button>
              {open2 && (
                <ul className="absolute  z-50 mt-2 bg-slate-400 text-black rounded shadow-lg left-0">
                  <li className="hover:text-blue-200 transition px-3 py-2"><Link onClick={() => { setOpen2(false); setOpen3(false); }} to="/leisure" >{t("services")}</Link></li>
                  <li className="hover:text-blue-200 transition px-3 py-2"><Link onClick={() => { setOpen2(false); setOpen3(false); }} to={"/leisure/trips/Arkaweet"}>{t("cambing")}</Link> </li>
                  <li className="hover:text-blue-200 transition px-3 py-2"><Link onClick={() => { setOpen2(false); setOpen3(false); }} to={"/leisure/sanganb"}>{t("sanganb")}</Link> </li>
                  <li className="hover:text-blue-200 transition px-3 py-2"><Link onClick={() => { setOpen2(false); setOpen3(false); }} to={"/leisure/trips/Irg"}>{t("arq")}</Link> </li>
                  <li className="hover:text-blue-200 transition px-3 py-2"><Link onClick={() => { setOpen2(false); setOpen3(false); }} to={"/leisure/trips/Romy"}>{t("rumi")}</Link> </li>
                  <li className="hover:text-blue-200 transition px-3 py-2"><Link onClick={() => { setOpen2(false); setOpen3(false); }} to={"/leisure/trips/Umbria"}>{t("umbria")}</Link> </li>

                </ul>
              )}
            </div>

            <div className="relative p-4 ">
              <button onClick={() => setOpen4(!open4)} className="bg-slate-400 text-black hover:text-gray-700 transition flex items-center gap-2 text-left">
                ⛑️{t("commercial")}
              </button>
              {open4 && (
                <ul className="absolute w-auto z-50 mt-2 bg-slate-400 text-black rounded shadow-lg left-0">

                  <li className="hover:text-blue-200 transition  px-3 py-2"><Link onClick={() => { setOpen4(false); setOpen3(false); }} to="/commircal" > {t("commercial")}</Link></li>
                  <li className="hover:text-blue-200 transition  px-3 py-2"><Link onClick={() => { setOpen4(false); setOpen3(false); }} to={"commircal/marineServis/ShipsSuplly"}>{t("supply")}</Link> </li>
                  <li className="hover:text-blue-200 transition  px-3 py-2"><Link onClick={() => { setOpen4(false); setOpen3(false); }} to={"commircal/marineServis/ShipHusbandry"}>{t("husbandry")}</Link> </li>
                  <li className="hover:text-blue-200 transition  px-3 py-2"><Link onClick={() => { setOpen4(false); setOpen3(false); }} to={"commircal/marineServis/CivilWokr"}>{t("civil")}</Link> </li>
                  <li className="hover:text-blue-200 transition  px-3 py-2"><Link onClick={() => { setOpen4(false); setOpen3(false); }} to={"commircal/marineServis/OffshoreWork"}>{t("offshore")}</Link> </li>
                </ul>
              )}
            </div>

            <div className="relative p-4 ">
              <button onClick={() => setOpen5(!open5)} className="bg-slate-400 text-black hover:text-gray-700 transition flex items-center gap-2 text-left">
                🥽{t("courses")}
              </button>
              {open5 && (
                <ul className="absolute w-auto z-50 mt-2 bg-slate-400 text-black rounded shadow-lg left-0">

                  <li className="hover:text-blue-200 transition  px-3 py-2"><Link onClick={() => { setOpen5(false); setOpen3(false); }} to="/courses/Courses">{t("courses")}</Link></li>
                  <li className="hover:text-blue-200 transition  px-3 py-2"><Link onClick={() => { setOpen5(false); setOpen3(false); }} to={"/courses/Courses/DiveCourses"}>{t("dive")}</Link> </li>
                  <li className="hover:text-blue-200 transition  px-3 py-2"><Link onClick={() => { setOpen5(false); setOpen3(false); }} to={"/courses/Courses/KidsCourses"}>{t("kid")}</Link> </li>

                </ul>
              )}
            </div>

            <Link to="/" onClick={() => setOpen3(false)} className="  hover:text-blue-200 transition p-4 ">🏠{t("home")}</Link>
            <Link to="/contact" onClick={() => setOpen3(false)} className="hover:text-blue-200 transition p-4">☎️{t("contact")}</Link>
            <Link to="/about" onClick={() => setOpen3(false)} className="hover:text-blue-200 transition p-4">📝{t("about")}</Link>
          </ul>
        </div>
      </div>
      {/* 🌊⛑️🛠️☎️🏠🏊🥽//////////////////////////////////////////////////////////////////////////////////////////////////////////////////// */}

      <nav ref={menuRef} className=" text-xl  hidden  md:flex gap-6 
      fixed w-full z-50 top-0 p-5 bg-slate-400
       text-black shadow-xl ">
        <img src={logo} className="w-[100px] h-[60px]" />

        <div className="relative">
          <button
            onClick={() => { setOpen(!open); setOpen2(false); setOpen4(false); setOpen5(false); }}
            className="bg-slate-400  hover:text-slate-200 transition" >
            🌐 {i18n.language.toUpperCase()}
          </button>
          {open && (
            <ul className="absolute z-50 mt-2 w-24 bg-white text-black rounded shadow-lg">
              <li
                onClick={() => changeLanguage("en")}
                className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
              >
                EN
              </li>
              <li
                onClick={() => changeLanguage("ar")}
                className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
              >
                AR
              </li>
            </ul>
          )}
        </div>
        <Link to="/" className="hover:text-slate-200 transition px-5 ">🏠{t("home")}</Link>

        <div className="relative">
          <button onClick={() => { setOpen2(!open2); setOpen(false); setOpen4(false); setOpen5(false); }} className="bg-slate-400  hover:text-slate-200 transition">
            🌊{t("services")}
          </button>
          {open2 && (
            <ul className="absolute  hover:text-slate-200 z-50 mt-2  bg-slate-400 text-black rounded shadow-lg left-0">
              <li className=" transition px-3 py-2"><Link onClick={() => setOpen2(false)} to="/leisure" >{t("services")}</Link></li>
              <li className=" transition px-3 py-2"><Link onClick={() => setOpen2(false)} to={"/leisure/trips/Arkaweet"}>{t("cambing")}</Link> </li>
              <li className=" transition px-3 py-2"><Link onClick={() => setOpen2(false)} to={"/leisure/sanganb"}>{t("sanganb")}</Link> </li>
              <li className=" transition px-3 py-2"><Link onClick={() => setOpen2(false)} to={"/leisure/trips/Irg"}>{t("arq")}</Link> </li>
              <li className=" transition px-3 py-2"><Link onClick={() => setOpen2(false)} to={"/leisure/trips/Romy"}>{t("rumi")}</Link> </li>
              <li className=" transition px-3 py-2"><Link onClick={() => setOpen2(false)} to={"/leisure/trips/Umbria"}>{t("umbria")}</Link> </li>

            </ul>
          )}
        </div>

        <div className="relative">
          <button onClick={() => { setOpen4(!open4); setOpen(false); setOpen2(false); setOpen5(false); }} className="bg-slate-400 hover:text-slate-200 transition">
            🛠️{t("commercial")}
          </button>
          {open4 && (
            <ul className="hover:text-slate-200 absolute w-auto z-50 mt-2  bg-slate-400 rounded shadow-lg left-0">

              <li className=" transition  px-3 py-2"><Link onClick={() => setOpen4(false)} to="/commircal" > {t("commercial")}</Link></li>
              <li className=" transition  px-3 py-2"><Link onClick={() => setOpen4(false)} to={"commircal/marineServis/ShipsSuplly"}>{t("supply")}</Link> </li>
              <li className=" transition  px-3 py-2"><Link onClick={() => setOpen4(false)} to={"commircal/marineServis/ShipHusbandry"}>{t("husbandry")}</Link> </li>
              <li className=" transition  px-3 py-2"><Link onClick={() => setOpen4(false)} to={"commircal/marineServis/CivilWokr"}>{t("civil")}</Link> </li>
              <li className=" transition  px-3 py-2"><Link onClick={() => setOpen4(false)} to={"commircal/marineServis/OffshoreWork"}>{t("offshore")}</Link> </li>
            </ul>
          )}
        </div>

        <div className="relative">
          <button onClick={() => { setOpen5(!open5); setOpen(false); setOpen2(false); setOpen4(false); }
          } className="bg-slate-400  hover:text-slate-200 transition">
            🥽{t("courses")}
          </button>
          {open5 && (
            <ul className="hover:text-slate-200 absolute w-auto z-50 mt-2 bg-slate-400 text-black rounded shadow-lg left-0">

              <li className=" transition  px-3 py-2"><Link onClick={() => setOpen5(false)} to="/courses/Courses">{t("courses")}</Link></li>
              <li className=" transition  px-3 py-2"><Link onClick={() => setOpen5(false)} to={"/courses/Courses/DiveCourses"}>{t("dive")}</Link> </li>
              <li className=" transition  px-3 py-2"><Link onClick={() => setOpen5(false)} to={"/courses/Courses/KidsCourses"}>{t("kid")}</Link> </li>

            </ul>
          )}
        </div>
        <Link to="/contact" className="hover:text-slate-200  transition px-5">☎️{t("contact")}</Link>
        <Link to="/about" className="  hover:text-slate-200 ransition px-5 ">📝{t("about")}</Link>






      </nav>
    </div>
  )
}

export default Navbar;